// 放置話題榜和話題主頁 我的關注(話題) 共用方法

import { useStore } from 'vuex'
import vuexStore from "@/store";
import { followTopicAPI, cancelFollowTopicAPI } from '@/api'

const topicFolder = '/data/attachment/topic/';

//把header列的state移除
export const disableHeaderActive = () =>{
  vuexStore.commit('forum/setSelectedForum', '')
}

//闗注话题
export const followTopic = async (id) =>{
  try {
    const { head, body } = await followTopicAPI({ topic_id: id, showLoading: false })
    if(head.errCode === 0) {
      return 'success'
    }
    else if(head.errCode === 1004) {
      return 'notLogin'
    } else {
      throw new Error(head.errMsg)
    }
  } catch (error) {
    console.log(error);
    return error
  }
}

//取消关注话题
export const cannelFollowTopic = async(id) =>{
  try {
    const { head, body } = await cancelFollowTopicAPI({ topic_id: id, showLoading: false })
    if(head.errCode === 0) {
      return 'success'
    }
    else if(head.errCode === 1004) {
      return 'notLogin'
    } else {
      throw new Error(head.errMsg)
    }
  } catch (error) {
    console.log(error);
    return error
  }
}

